import { Auth } from 'aws-amplify';

async function idToken() {
  const session = await Auth.currentSession();
  return session.idToken.jwtToken;
}

export default idToken;
